import React, { Component } from 'react'

import Plyr from './plyr'

class PMIntro extends Component {

  render() {
    const { heading, subheading, content, videoId } = this.props

    return (
      <section className='property-management-intro' data-color='#FFFFFF'>
        <div className='property-management-intro__inner'>
          <div className='property-management-intro__content'>
            <h2>{ heading }</h2>
            <h3 dangerouslySetInnerHTML={{ __html: subheading }}/>
            <div dangerouslySetInnerHTML={{ __html: content }}/>
          </div>
          <div className='property-management-intro__video'>
            <Plyr
              type="youtube"
              ref='player'
              videoId={ videoId }
              urls={{
                youtube: {
                  api: 'https://noembed.com/embed?url={0}'
                }
              }}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default PMIntro
